import { render, staticRenderFns } from "./RouteGroupDetail.vue?vue&type=template&id=eeda1da4&scoped=true&"
import script from "./RouteGroupDetail.vue?vue&type=script&lang=js&"
export * from "./RouteGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./RouteGroupDetail.vue?vue&type=style&index=0&id=eeda1da4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeda1da4",
  null
  
)

export default component.exports